import React, { useCallback } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  EntityCriteriaCompoundOperatorInput,
  EntitySelectionCriteriaInput,
} from '../../../../types/generated-types';
import { QueryableFieldsQuery } from '../../../../types/generated-types';
import { EntitySelectionCriteriaBuilder } from './EntitySelectionCriteriaBuilder';
import { TieredEntitySelectionBuilder } from './TieredEntitySelectionBuilder';

interface CompoundOperatorBuilderProps {
  operator: EntityCriteriaCompoundOperatorInput;
  onChange: (operator: EntityCriteriaCompoundOperatorInput) => void;
  onRemove: () => void;
  targetModel: string;
  fieldsData: QueryableFieldsQuery['queryableFields'];
}

export const CompoundOperatorBuilder: React.FC<
  CompoundOperatorBuilderProps
> = ({ operator, onChange, onRemove, targetModel, fieldsData }) => {
  const handleOperatorChange = useCallback(
    (newOperator: string) => {
      onChange({
        ...operator,
        operator: newOperator,
      });
    },
    [operator, onChange],
  );

  const handleCriteriaChange = useCallback(
    (criteria: EntitySelectionCriteriaInput) => {
      onChange({
        ...operator,
        criteria,
      });
    },
    [operator, onChange],
  );

  return (
    <Box
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="subtitle1">Compound Operator</Typography>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Operator</InputLabel>
          <Select
            value={operator.operator}
            onChange={(e) => handleOperatorChange(e.target.value)}
            label="Operator"
          >
            <MenuItem value="and">AND</MenuItem>
            <MenuItem value="or">OR</MenuItem>
          </Select>
        </FormControl>
        <IconButton onClick={onRemove} color="error">
          <DeleteIcon />
        </IconButton>
      </Box>

      <EntitySelectionCriteriaBuilder
        criteria={operator.criteria}
        onChange={handleCriteriaChange}
        targetModel={targetModel}
      />
    </Box>
  );
};
